import Vue from 'vue';

import BackBtn from '@/components/BackBtn.vue';
import ListTitle from '@/components/ListTitle.vue';
import ModelTitle from '@/components/ModelTitle.vue';
import EntityDialogHeader from '@/components/EntityDialogHeader.vue';
import PaymentProviderChip from '@/components/PaymentProviderChip.vue';


Vue.component('BackBtn', BackBtn)
Vue.component('ListTitle', ListTitle)
Vue.component('ModelTitle', ModelTitle)
Vue.component('EntityDialogHeader', EntityDialogHeader)
Vue.component('PaymentProviderChip', PaymentProviderChip)
